import script from "./JaContentRow.vue?vue&type=script&setup=true&lang=js"
export * from "./JaContentRow.vue?vue&type=script&setup=true&lang=js"

import "./JaContentRow.vue?vue&type=style&index=0&id=4bf37f11&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4bf37f11"]])

export default __exports__